import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sumErrorLogs',
  pure: true,
})
export class SumErrorLogsPipe implements PipeTransform {
  transform(labs?: Array<{ unviewedErrorLogCount?: number }>): number {
    return (labs ?? []).reduce((a, l) => a + (l.unviewedErrorLogCount ?? 0), 0);
  }
}
